import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import { faPlus, faTruckFast, faUsers, faBoxOpen } from "@fortawesome/free-solid-svg-icons";

// role دايمًا array عشان .includes() يشتغل بشكل صحيح ودقيق
// (لو تسيبها string زي "1995"، فحص .includes("1") هيرجع true غلط)
export const links = [
    {
        name: "Users",
        translationKey: "users",
        path: "users",
        icon: faUsers,
        role: [ "1995" ],
    },
    {
        name: "Add User",
        translationKey: "addUser",
        path: "/dashboard/users/add",
        icon: faPlus,
        role: [ "1995" ],
    },
    {
        name: "Categories",
        translationKey: "categories",
        path: "/dashboard/categories",
        icon: faProductHunt,
        role: [ "1999", "1995" ],
    },
    {
        name: "Add Categories",
        translationKey: "addCategories",
        path: "/dashboard/category/add",
        icon: faProductHunt,
        role: [ "1999", "1995" ],
    },
    {
        name: "Products",
        translationKey: "products",
        path: "/dashboard/products",
        icon: faTruckFast,
        role: [ "1999", "1995" ],
    },
    {
        name: "Add Products",
        translationKey: "addProducts",
        path: "/dashboard/products/add",
        icon: faProductHunt,
        role: [ "1999", "1995" ],
    },
    {
        name: "Orders",
        translationKey: "orders",
        path: "/dashboard/orders",
        icon: faBoxOpen,
        role: [ "1999", "1995" ],
    },
    {
        name: "Writer",
        translationKey: "writer",
        path: "/dashboard/writer",
        icon: faPlus,
        role: [ "1995", "1996" ],
    },
];
